// Controller Functions to Use Toasted Notifications

export function startToast (vm, msg) {
    const config = {type: "info"}
    vm.proxy.$toasted.clear()
    vm.proxy.$toasted.show(msg, config)
}

export function endToast(vm, msg){
    const config = {type: "success", duration: 1000}
    vm.proxy.$toasted.clear()
    vm.proxy.$toasted.show(msg, config)
}